import { type FunctionComponent, type PropsWithChildren } from 'react';
import { badgeStyle, hideCountStyle } from './badge.css';

export type BadgeProps = {
	count: number;
	condensed?: boolean;
	noMargin?: boolean;
	hideCount?: boolean;
	className?: string;
};

export const Badge: FunctionComponent<PropsWithChildren<BadgeProps>> = ({
	count,
	condensed,
	noMargin,
	hideCount,
	children,
	className = ''
}) => {
	const phValue = hideCount ? hideCountStyle : condensed ? 'ph1' : 'ph2';
	const pvValue = !hideCount && !condensed ? 'pv1' : '';
	const hasChildrenStyles = children ? `absolute ${badgeStyle}` : '';
	const wrapperMargin = noMargin ? '' : 'mr4';
	return (
		<div className={`dib relative ${wrapperMargin}`}>
			{children}
			{count !== 0 && (
				<div
					data-testid="badge-count"
					className={`f7 fw5 monospace top-0 right-0 bg-theme-emphasis theme-white ${phValue} ${pvValue} br-pill ba b--theme-white ${hasChildrenStyles} ${className}`}>
					{!hideCount && (count < 100 ? count : '99+')}
				</div>
			)}
		</div>
	);
};
